export enum Role {
  ADMIN = "Admin",
  STANDARD = "Standard",
}
